import type { ClientToolImpl } from './context.js'

/**
 * Browser-only runtime registry of client-tool executors. Plugins call
 * `registerClientToolImpl` at module load (from plugin entry) the same way
 * agent-command applicators are wired. The dispatcher reads from this
 * registry on each `onToolCall` from the Vercel AI SDK Chat instance.
 *
 * The Node-safe spec data (name, description, JSON schema) lives in
 * `./specs.ts` — the Lambda imports specs but never the executors.
 */
const impls = new Map<string, ClientToolImpl>()

export const registerClientToolImpl = (name: string, fn: ClientToolImpl): void => {
  if (impls.has(name)) {
    throw new Error(`Client-tool impl already registered: ${name}`)
  }
  impls.set(name, fn)
}

export const getClientToolImpl = (name: string): ClientToolImpl | undefined => impls.get(name)

/** Test helper — clears the registry between tests. Not for production use. */
export const clearClientToolImpls = (): void => {
  impls.clear()
}
